import HTTP from './http'
import Store from '@/store'
const BASE_URL = '/company'

const currentUsersCompanyKey = () =>
  Store.getters['user/accountInfo'].company ? Store.getters['user/accountInfo'].company.companyKey : 0

export default {
  async register(companyDetails) {
    const response = await HTTP.post(`${BASE_URL}/`, companyDetails)
    return response.data.data
  },

  async update(companyDetails) {
    const response = await HTTP.put(`${BASE_URL}/`, companyDetails)
    return response.data.data
  },

  async getCompanyUsers(companyKey) {
    const params = {
      companyKey: companyKey || currentUsersCompanyKey()
    }
    const response = await HTTP.get(`${BASE_URL}/user/list`, { params })
    return response.data.data
  },

  async getDetails(companyKey) {
    const params = {
      companyKey
    }
    const response = await HTTP.get(`${BASE_URL}`, { params })
    return response.data.data
  },

  async createSubscription({ companyKey, billingInfo }) {
    const key = companyKey || currentUsersCompanyKey()
    const response = await HTTP.post(`${BASE_URL}/${key}/subscriptions`, billingInfo)
    return response.data.data
  },

  async getInvoices({ companyKey }) {
    const key = companyKey || currentUsersCompanyKey()
    const response = await HTTP.get(`${BASE_URL}/${key}/invoices`)
    return response.data.data
  },

  async updatePaymentMethod({ paymentMethodInfo, companyKey }) {
    const key = companyKey || currentUsersCompanyKey()
    const response = await HTTP.post(`${BASE_URL}/${key}/payment-method`, paymentMethodInfo)
    return response.data.data
  }
}
